import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { InputGroup } from "@Components/Input/InputGroups"
import { Spacer } from "@Components/Space"
import { Ionicons } from "@expo/vector-icons"
import React, { useContext, useEffect, useState } from "react"
import DropDownPicker from "react-native-dropdown-picker"
import DateTimePicker from "@react-native-community/datetimepicker"
import { baseColors } from "@Constants/baseStyles"
import { Alert, Platform, TouchableOpacity, View } from "react-native"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { CustomPicker } from "@Components/FollowUp/Toolbox/CustomPicker"
import { ReminderService } from "@Services/Reminder.Service"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { dbDateFormat, dbDateTimeFormat, isNumber, isValidTime, localDateFormat, removeTimeZone } from "@Utils/utils"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { reminderPayloadAtom, remindersListAtom, reminderTypesAtom } from "@Recoil/Atom/reminderAtom"
import { ModalCreateRecurrence } from "./ModalCreateRecurrence"
import {
    ReminderContext,
    defaultReminderDateTime,
    defaultReminderDateTimeFormat,
    defaultReminderPayload
} from "@Providers/ReminderProvider"

const moment = require("moment")

const declencheurs = [
    {
        id: 1,
        label: "Minutes avant",
        value: "minute"
    },
    {
        id: 2,
        label: "Heures avant",
        value: "hour"
    },
    {
        id: 3,
        label: "Jours avant",
        value: "day"
    },
    {
        id: 4,
        label: "Semaines avant",
        value: "week"
    }
]

const recurrences = [
    {
        id: 1,
        label: "Une seule fois",
        value: "once"
    },
    { id: 2, label: "Tous les jours", value: "day" },
    { id: 3, label: "Toutes les semaine", value: "week" },
    { id: 4, label: "Toutes les mois", value: "month" },
    { id: 5, label: "Toutes les ans", value: "year" },
    { id: -1, label: "Personnalisé", value: "custom" }
]

let everyDayRecurrence = {
    frequency: 1,
    frequencyUnit: "day"
}

let everyWeekRecurrence = {
    frequency: 1,
    frequencyUnit: "week"
}

let everyMonthRecurrence = {
    frequency: 1,
    frequencyUnit: "month"
}

let everyYearRecurrence = {
    frequency: 1,
    frequencyUnit: "year"
}

let onceRecurrence = {
    frequency: 1,
    frequencyUnit: "once",
    onlyRecurrenceDate: defaultReminderDateTime
}

let customRecurrence = {
    frequency: 1,
    frequencyUnit: "week",
    recurrenceDays: []
}

export const defaultReminder = {
    patientId: null,
    name: "",
    reminderTypeId: null,
    deadline: defaultReminderDateTime,
    time: null,
    recurrence: {
        frequency: 1,
        frequencyUnit: "week",
        onlyRecurrenceDate: defaultReminderDateTime,
        recurrenceDays: []
    },
    timeBefore: 10,
    timeBeforeUnit: "minute"
}

export const ReminderForm = ({ navigation, route }) => {
    const user = useRecoilValue(userAtom)
    const [editMode, setEditMode] = useState(false)
    const [open, setOpen] = useState(false)
    const [value, setValue] = useState(null)
    const [loading, setLoading] = useState(false)
    const [datePickerVisible, setDatePickerVisible] = useState(false)
    const [datePickerDisplay, setDatePickerDisplay] = useState("inline")
    const [selectedRecurrence, setSelectedRecurrence] = useState(null)
    const [openModalCreateRecurrence, setOpenModalCreateRecurrence] = useState(false)
    const [dateTimePickerMode, setMode] = useState("date")
    const [types, setTypes] = useRecoilState(reminderTypesAtom)
    const setRemindersList = useSetRecoilState(remindersListAtom)
    const { reminder, setReminder } = useContext(ReminderContext)
    const [date, setDate] = useState(new Date().toISOString().split("T")[0])
    const [time, setTime] = useState(moment(new Date()).format("HH:mm"))

    const getReminders = async (callBack) => {
        const response = await ReminderService.getList()
        const reminders = response?.data?.data
        if (reminders) {
            setRemindersList(reminders)
        }
        callBack?.()
    }

    const performSaveReminder = () => {
        let data = reminder
        if (user?.id) {
            setLoading(true)
            if (editMode && data.id) {
                ReminderService.put(data.id, data)
                    .then((response) => {
                        const reminderNotification = response?.data
                        setLoading(false)
                        setReminder(data)
                        setReminder(defaultReminderPayload)
                        getReminders(() => navigation.goBack())
                        ShowToast({ type: "success", message: message.updatedSuccess })
                    })
                    .catch((e) => {
                        ShowToast({ type: "error", message: message.serverError })
                        setLoading(false)
                    })
            } else {
                ReminderService.create(data)
                    .then((response) => {
                        const reminderNotification = response?.data?.data
                        setLoading(false)
                        // console.log({ payload: data, response: reminderNotification })
                        if (response.data.code === 200) {
                            setReminder(defaultReminderPayload)
                            ShowToast({ type: "success", message: "Rappel créé avec succès !" })
                            getReminders(() => navigation.goBack())
                        } else {
                            ShowToast({ type: "error", message: message.serverError })
                        }
                    })
                    .catch((e) => {
                        ShowToast({ type: "error", message: message.serverError })
                        setLoading(false)
                    })
            }
        } else {
            alert("No user id")
        }
    }

    const fetchReminderTypes = () => {
        ReminderService.getTypes().then((response) => {
            const data = response.data?.data
            if (data) {
                let parsed = data.map((d) => {
                    return {
                        label: d?.name,
                        value: d?.id
                    }
                })
                setTypes(parsed)
            }
        })
    }

    useEffect(() => {
        let recurrencePayLoad = onceRecurrence
        switch (selectedRecurrence) {
            case -1:
                recurrencePayLoad = customRecurrence
                break
            case 1:
                recurrencePayLoad = onceRecurrence
                break
            case 2:
                recurrencePayLoad = everyDayRecurrence
                break
            case 3:
                recurrencePayLoad = everyWeekRecurrence
                break
            case 4:
                recurrencePayLoad = everyMonthRecurrence
                break
            case 5:
                recurrencePayLoad = everyYearRecurrence
                break
            default:
                recurrencePayLoad = everyDayRecurrence
                break
        }
        setReminder((old) => ({ ...old, recurrence: recurrencePayLoad }))
    }, [selectedRecurrence])

    useEffect(() => {
        if (reminder?.recurrence?.frequencyUnit === "once") {
            setReminder((old) => ({
                ...old,
                recurrence: {
                    ...reminder.recurrence,
                    onlyRecurrenceDate: moment(reminder.deadline, dbDateTimeFormat).format(dbDateTimeFormat)
                }
            }))
        }
    }, [reminder.deadline, reminder?.recurrence?.frequencyUnit])

    const confirmDelete = () => {
        Alert.alert("Suppression", "Voulez-vous vraiment vous supprimer ce rappel ?", [
            {
                text: "Annuler",
                onPress: () => {}
            },
            {
                text: "Supprimer",
                onPress: () => performDelete()
            }
        ])
    }

    const performDelete = () => {
        if (reminder?.id) {
            setLoading(true)
            ReminderService.deleteById(reminder.id)
                .then((response) => {
                    if (response?.data.status === "SUCCESS") {
                        setReminder(defaultReminderPayload)
                        navigation.goBack()
                        ShowToast({ type: "success", message: message.deletedSuccess })
                    } else {
                        ShowToast({ type: "error", message: response.data.status })
                    }

                    setLoading(false)
                })
                .catch((e) => {
                    ShowToast({ type: "error", message: message.serverError })
                    setLoading(false)
                })
        }
    }

    const onChangeDateTime = (event, selectedDate) => {
        setDatePickerVisible(false)
        const currentDate = selectedDate
        if (currentDate) {
            if (dateTimePickerMode == "time") {
                setReminder((old) => ({ ...old, time: moment(currentDate).format("HH:mm") }))
            } else {
                setReminder((old) => ({ ...old, deadline: moment(currentDate).format("YYYY-MM-DD 23:59:00") }))
            }
        }
    }

    const onChangeWebDateTime = (datimeValue, isTime) => {
        setDatePickerVisible(false)
        if (datimeValue) {
            if (isTime) {
                setReminder((old) => ({ ...old, time: datimeValue }))
            } else {
                setReminder((old) => ({ ...old, deadline: moment(datimeValue).format("YYYY-MM-DD 23:59:00") }))
            }
        }
    }

    const showDatePicker = () => {
        setMode("date")
        setDatePickerDisplay("inline")
        setDatePickerVisible(true)
    }

    const showTimePicker = () => {
        setMode("time")
        setDatePickerDisplay("spinner")
        setDatePickerVisible(true)
    }

    useEffect(() => {
        if (user?.id) {
            setReminder((old) => ({ ...old, patientId: user?.id }))
        }

        if (route.params && route.params.data != undefined) {
            setEditMode(true)
        }

        const reminderItem = route?.params?.data
        console.log({ reminderItem })

        if (reminderItem) {
            setReminder({
                patientId: user?.id,
                id: reminderItem?.id,
                name: reminderItem?.name,
                reminderTypeId: reminderItem.type?.id,
                deadline: moment(removeTimeZone(reminderItem.deadline)).format(defaultReminderDateTimeFormat),
                time: reminderItem.time,
                timeBefore: reminderItem.timeBefore,
                timeBeforeUnit: reminderItem.timeBeforeUnit,
                recurrence: reminderItem.recurrence
            })
            setTime(reminderItem.time)
            setDate(moment(reminderItem.deadline).format(dbDateFormat))
            if (reminderItem?.recurrence?.recurrenceDays?.length != 0 || reminderItem?.recurrence?.frequency > 1) {
                setSelectedRecurrence(-1)
            } else {
                let found = recurrences.filter((item) => item.value === reminderItem?.recurrence?.frequencyUnit)
                if (found?.length > 0) {
                    setSelectedRecurrence(found[0].id)
                }
            }
        }
    }, [])

    useEffect(() => {
        if (types?.length === 0) {
            fetchReminderTypes()
        }

        return () => {
            setReminder(defaultReminderPayload)
        }
    }, [])

    useEffect(() => {
        if (value) setReminder((old) => ({ ...old, reminderTypeId: value }))
    }, [value])

    const canSubmit = () =>
        reminder?.name?.length > 0 &&
        reminder?.reminderTypeId &&
        reminder?.deadline &&
        isValidTime(reminder.time) &&
        reminder?.recurrence &&
        reminder?.timeBeforeUnit &&
        isNumber(reminder?.timeBefore)

    return (
        <>
            <ContainerStackScreen>
                <CustomScrollview showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: 100 }}>
                    <ModalCreateRecurrence
                        toggleModal={() => setOpenModalCreateRecurrence(false)}
                        openModal={openModalCreateRecurrence}
                    />
                    <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                        {editMode ? "Modifier le rappel " : "Créer un rappel"}
                    </BreeSerifText>

                    <Spacer height={15} />

                    <OpenSansText fontSize={16}>
                        Pensez à activer les notifications dans les paramètres pour recevoir une alerte !
                    </OpenSansText>

                    <Spacer height={30} />

                    <OpenSansText fontSize={16}>Type de rappel</OpenSansText>

                    <Spacer height={20} />

                    <View style={{ zIndex: 2000 }}>
                        <DropDownPicker
                            disabled={loading}
                            placeholder={"Sélectionnez un type de rappel"}
                            style={{ height: 47, borderWidth: 0, backgroundColor: baseColors.green.light }}
                            dropDownContainerStyle={{ borderColor: baseColors.green.primary }}
                            itemSeparator
                            itemSeparatorStyle={{ backgroundColor: baseColors.green.primary }}
                            ArrowDownIconComponent={() => (
                                <Ionicons color={baseColors.green.primary} size={20} name={"chevron-down"} />
                            )}
                            textStyle={{ color: baseColors.black, fontSize: 16 }}
                            ArrowUpIconComponent={() => (
                                <Ionicons color={baseColors.green.primary} size={20} name={"chevron-up"} />
                            )}
                            placeholderStyle={{ fontFamily: "OpenSans", fontSize: 16, color: baseColors.green.primary }}
                            open={open}
                            value={reminder?.reminderTypeId}
                            items={types}
                            setOpen={setOpen}
                            setValue={setValue}
                            setItems={setTypes}
                        />
                    </View>

                    <Spacer height={20} />

                    <InputGroup
                        disabled={loading}
                        validation_message="obligatoire"
                        label="Nom du rappel"
                        placeholder="Entrez votre texte"
                        value={reminder?.name}
                        onChange={(txt) => setReminder((old) => ({ ...old, name: txt }))}
                    />
                    <Spacer height={15} />

                    {Platform.OS === "web" ? (
                        <View>
                            <View>
                                <OpenSansText fontWeight={"bold"} fontSize={16}>
                                    Échéance
                                </OpenSansText>
                                <input
                                    disabled={loading}
                                    style={{
                                        height: 50,
                                        borderRadius: 10,
                                        paddingRight: 20,
                                        paddingLeft: 10,
                                        fontSize: 14,
                                        marginTop: 10,
                                        marginBottom: 20
                                    }}
                                    type="date"
                                    value={date}
                                    onChange={(e) => {
                                        const dateValue = e.target.value
                                        setDate(dateValue)
                                        onChangeWebDateTime(dateValue)
                                    }}
                                />
                            </View>

                            <View>
                                <OpenSansText fontWeight={"bold"} fontSize={16}>
                                    Heure du rappel
                                </OpenSansText>
                                <input
                                    disabled={loading}
                                    style={{
                                        height: 50,
                                        borderRadius: 10,
                                        paddingRight: 20,
                                        paddingLeft: 10,
                                        fontSize: 14,
                                        marginTop: 10,
                                        marginBottom: 20
                                    }}
                                    type="time"
                                    value={time}
                                    onChange={(e) => {
                                        const timeValue = e.target.value
                                        setTime(timeValue)
                                        onChangeWebDateTime(timeValue, true)
                                    }}
                                />
                            </View>
                        </View>
                    ) : (
                        <View>
                            <TouchableOpacity onPress={() => showDatePicker()}>
                                <InputGroup
                                    editable={false}
                                    disabled={loading}
                                    value={moment(reminder?.deadline).format(localDateFormat)}
                                    // onFocus={() => showDatePicker()}
                                    onTouch={() => showDatePicker()}
                                    validation_message={"obligatoire"}
                                    label="Échéance"
                                    placeholder={"Sélectionner une date"}
                                />
                            </TouchableOpacity>

                            <TouchableOpacity onPress={() => showTimePicker()}>
                                <InputGroup
                                    editable={false}
                                    disabled={loading}
                                    value={reminder?.time}
                                    // onFocus={() => showTimePicker()}
                                    onTouch={() => showTimePicker()}
                                    validation_message="obligatoire"
                                    label="Heure du rappel"
                                    placeholder="Sélectionner l'heure"
                                />
                            </TouchableOpacity>
                        </View>
                    )}

                    {/* <CustomSimpleModal toggleModal={() => setDatePickerVisible(false)} open={datePickerVisible}> */}
                    {datePickerVisible && (
                        <DateTimePicker
                            is24Hour
                            disabled={loading}
                            value={moment(reminder?.deadline, dbDateFormat).toDate()}
                            mode={dateTimePickerMode}
                            display={datePickerDisplay}
                            minimumDate={new Date()}
                            onChange={onChangeDateTime}
                        />
                    )}

                    {/* </CustomSimpleModal> */}

                    <OpenSansText fontSize={16}>Déclenchement du rappel</OpenSansText>

                    <Spacer height={20} />

                    <CustomPicker
                        value={
                            declencheurs.filter((itm) => itm.value === reminder?.timeBeforeUnit).length > 0
                                ? declencheurs.filter((itm) => itm.value === reminder?.timeBeforeUnit)[0].id
                                : null
                        }
                        disabled={loading}
                        customLabel={`${reminder?.timeBefore ? reminder?.timeBefore : ""} ${
                            reminder?.timeBeforeUnit
                                ? declencheurs.filter((itm) => itm.value === reminder.timeBeforeUnit).length > 0
                                    ? declencheurs.filter((itm) => itm.value === reminder.timeBeforeUnit)[0].label
                                    : ""
                                : ""
                        }`}
                        header={
                            <View style={{ marginHorizontal: 20, marginTop: 20 }}>
                                <InputGroup
                                    disabled={loading}
                                    code
                                    value={reminder?.timeBefore?.toString()}
                                    placeholder={"10 min"}
                                    onChange={(txt) => setReminder((old) => ({ ...old, timeBefore: txt }))}
                                />
                            </View>
                        }
                        data={declencheurs}
                        title={"Sélectionner un déclenchement"}
                        handleChange={(itemId) => {
                            if (itemId) {
                                setReminder((old) => ({
                                    ...old,
                                    timeBeforeUnit: declencheurs.filter((itm) => itm.id === itemId)[0].value
                                }))
                            }
                        }}
                    />
                    <Spacer height={20} />

                    <OpenSansText fontSize={16}>Récurrence</OpenSansText>

                    <Spacer height={20} />

                    <CustomPicker
                        value={selectedRecurrence}
                        disabled={loading}
                        onPressItem={(itemId) => {
                            if (itemId < 0) {
                                setOpenModalCreateRecurrence(true)
                            }
                        }}
                        handleChange={(itemId) => {
                            setSelectedRecurrence(itemId)
                        }}
                        data={recurrences}
                        title={"Sélectionner une récurrence"}
                    />

                    <Spacer height={20} />

                    <Button
                        onPress={() => performSaveReminder()}
                        disabled={loading || !canSubmit()}
                        loading={loading}
                        text={editMode ? "Enregistrer" : "Créer"}
                        width="100%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                    <Spacer height={20} />
                    {editMode && (
                        <TouchableOpacity disabled={loading} onPress={() => confirmDelete()} activeOpacity={0.7}>
                            <OpenSansText
                                fontSize={16}
                                color={baseColors.orange.primary}
                                style={{ textDecorationLine: "underline" }}
                                fontWeight={"bold"}
                                textAlign={"center"}
                            >
                                Supprimer le rappel
                            </OpenSansText>
                        </TouchableOpacity>
                    )}
                </CustomScrollview>
            </ContainerStackScreen>
        </>
    )
}
